// DriverListMobile.js — phone layout of the Driver / Conductor list: one compact card per record.
import { Avatar, Box, Pagination, Skeleton, Stack, Typography } from "@mui/material";
import { DASHBOARD_COLORS as C, STATUS_COLORS, statusDot } from "../components/DashboardCard";

function MobileField({ label, value }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontSize: 11.5, color: C.muted, lineHeight: 1.3 }}>{label}</Typography>
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: C.navy, overflowWrap: "anywhere", lineHeight: 1.35 }}>
        {value || "—"}
      </Typography>
    </Box>
  );
}

export default function DriverListMobile({ drivers = [], loading, renderActions, page = 0, pageSize = 10, onPageChange, emptyState }) {
  if (loading) {
    return (
      <Stack spacing={1} sx={{ p: 1.5 }} aria-label="Loading records">
        {[0, 1, 2].map((key) => (
          <Skeleton key={key} variant="rounded" height={112} sx={{ borderRadius: "10px" }} />
        ))}
      </Stack>
    );
  }
  if (!drivers.length) return emptyState;

  const pageCount = Math.ceil(drivers.length / pageSize);
  const visible = drivers.slice(page * pageSize, (page + 1) * pageSize);

  return (
    <Box sx={{ p: 1.25 }}>
      <Stack spacing={1} component="ul" sx={{ listStyle: "none", m: 0, p: 0 }}>
        {visible.map((d) => {
          const status = STATUS_COLORS[d.police_station_level1_status?.toLowerCase()];
          return (
            <Box
              component="li"
              key={d.driver_id}
              sx={{ border: `1px solid ${C.border}`, borderRadius: "10px", p: 1.25, bgcolor: "#fff", minWidth: 0 }}
            >
              <Box display="flex" alignItems="center" gap={1.25} minWidth={0}>
                <Avatar src={d.upload_photo} alt="" sx={{ width: 40, height: 40, bgcolor: C.primarySoft, color: C.primary, fontSize: 16, fontWeight: 600 }}>
                  {d.contact_person?.charAt(0)?.toUpperCase()}
                </Avatar>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography sx={{ fontSize: 15, fontWeight: 600, color: C.navy, lineHeight: 1.3, overflowWrap: "anywhere" }}>
                    {d.contact_person || "Unnamed"}
                  </Typography>
                  <Typography sx={{ fontSize: 12.5, color: C.muted }}>{d.firm_types || d.designation || "—"}</Typography>
                </Box>
                {status && (
                  <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, fontSize: 12, fontWeight: 600, color: status.color, flexShrink: 0 }}>
                    <Box component="span" sx={statusDot(status.color)} />
                    {status.label}
                  </Box>
                )}
              </Box>
              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 1, mt: 1 }}>
                <MobileField label="Reg No" value={d.register_no} />
                <MobileField label="Mobile" value={d.mobile1} />
                <MobileField label="DL No" value={d.dl_no} />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 0.75, mt: 1, pt: 1, borderTop: "1px solid #EEF2F6" }}>
                {renderActions?.(d)}
              </Box>
            </Box>
          );
        })}
      </Stack>
      {pageCount > 1 && (
        <Stack alignItems="center" mt={1.5}>
          <Pagination
            count={pageCount}
            page={page + 1}
            onChange={(e, value) => onPageChange?.(value - 1)}
            color="primary"
            size="small"
            siblingCount={0}
            showFirstButton
            showLastButton
          />
        </Stack>
      )}
    </Box>
  );
}
